import { Component, OnInit, Input, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';
import { CardPresentationComponent } from 'app/core/components/workflow-new/common/card-presentation';

@Component({
  selector: 'itpx-course-card-presentation',
  templateUrl: './course-card-presentation.component.html',
  styleUrls: ['../../common/style.css'],
  providers: [{ provide: CardPresentationComponent, useExisting: forwardRef(() => CourseCardPresentationComponent) }],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class CourseCardPresentationComponent extends CardPresentationComponent {

  examStatus: string;
  constructor( ) { super(); }


  getLocation(venue: any): string {
    return [venue.address, venue.city, venue.country].filter(v => v).join(', ');

  }

  ngOnInit(){
    if (this.platformClass.expired) {
      this.examStatus = 'Finished';
    } else if (('assignment' === this.platformClass.type || 'exam' === this.platformClass.type) && this.platformClass.exam) {
      if (this.platformClass.exam.status && this.platformClass.exam.status.configKey) {
        switch (this.platformClass.exam.status.configKey) {
          case 'fulfilled':
          case 'inProgress':
            this.examStatus = 'Booked';
            break;
          default:
            this.examStatus = 'Scheduling';
            break;
        }
      } else {
        this.examStatus = this.platformClass.status.toLowerCase() === 'assigned' ? 'Scheduling' : 'Booked';
      }
    }
    // console.log(this.platformClass)
  }


}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/course-card-presentation/course-card-presentation.component.ts